import { UserSummary } from "@accurx/concierge/types";

export const getPreviewSummaryNote = (note: UserSummary | undefined) => {
    if (note) {
        return note.isCurrentUser ? "You" : note.displayName;
    }
    return "Unknown user";
};
